import React from 'react'
import { Link } from 'react-router-dom'

const SideBar = () => {
  return (
    <div className="sidebar-page-container">
  <div className="auto-container">
    <div className="row clearfix">
      {/*Content Side / Blog Sidebar*/}
      <div className="content-side col-lg-8 col-md-12 col-sm-12">
        <div className="blog-sidebar">
          {/* News Block Four */}
          <div className="news-block style-four wow fadeInRight">
            <div className="inner-box">
              <div className="image-box">
                <span className="tag">Participants</span>
                <figure className="image">
                  <Link  to="blog-single.html">
                    <img src="/assets/images/resource/blog-1.jpg" alt="" />
                  </Link> 
                </figure>
              </div>
              <div className="lower-content">
                <div className="author">
                  <figure className="thumb">
                    <img src="/assets/images/resource/author-thumb-1.jpg" alt="" />
                  </figure>
                  <h5 className="name">Thomas Albart</h5>
                </div>
                <ul className="post-info">
                  <li>
                    <span className="far fa-calendar" /> 31/12/2023
                  </li>
                  <li>
                    <span className="far fa-comments" /> 02 Comments
                  </li>
                </ul>
                <h4>
                  <Link  to="blog-single.html">
                    Chances are Good That There’s a Cloud Software as{" "}
                  </Link> 
                </h4>
                <div className="text">
                  Single stroke at the present moment and yet I feel that lorem
                  quis bibendum auctor. Elitm sed eiusmod tempor incididunt umst
                  etsu dolore magna aliquatenim ad.
                </div>
              </div>
            </div>
          </div>
          {/* News Block Four */}
          <div className="news-block style-four wow fadeInRight">
            <div className="inner-box">
              <div className="image-box">
                <span className="tag">Virtual</span>
                <figure className="image">
                  <Link  to="blog-single.html">
                    <img src="/assets/images/resource/blog-2.jpg" alt="" />
                  </Link> 
                </figure>
              </div>
              <div className="lower-content">
                <div className="author">
                  <figure className="thumb">
                    <img src="/assets/images/resource/author-thumb-2.jpg" alt="" />
                  </figure>
                  <h5 className="name">Jamika Lora</h5>
                </div>
                <ul className="post-info">
                  <li>
                    <span className="far fa-calendar" /> 31/12/2023
                  </li>
                  <li>
                    <span className="far fa-comments" /> 02 Comments
                  </li>
                </ul>
                <h4>
                  <Link  to="blog-single.html">
                    Chances are Good That There’s a Cloud Software as{" "}
                  </Link> 
                </h4>
                <div className="text">
                  Single stroke at the present moment and yet I feel that lorem
                  quis bibendum auctor. Elitm sed eiusmod tempor incididunt umst
                  etsu dolore magna aliquatenim ad.
                </div>
              </div>
            </div>
          </div>
          {/* News Block Four */}
          <div className="news-block style-four wow fadeInRight">
            <div className="inner-box">
              <div className="image-box">
                <span className="tag">Marketing</span>
                <figure className="image">
                  <Link  to="blog-single.html">
                    <img src="/assets/images/resource/blog-3.jpg" alt="" />
                  </Link> 
                </figure>
              </div>
              <div className="lower-content">
                <div className="author">
                  <figure className="thumb">
                    <img src="/assets/images/resource/author-thumb-3.jpg" alt="" />
                  </figure>
                  <h5 className="name">Nicky Monitor</h5>
                </div>
                <ul className="post-info">
                  <li>
                    <span className="far fa-calendar" /> 31/12/2023
                  </li>
                  <li>
                    <span className="far fa-comments" /> 02 Comments
                  </li>
                </ul>
                <h4>
                  <Link  to="blog-single.html">
                    We Have Top Executive and Start Up Here Event 2021
                  </Link> 
                </h4>
                <div className="text">
                  Single stroke at the present moment and yet I feel that lorem
                  quis bibendum auctor. Elitm sed eiusmod tempor incididunt umst
                  etsu dolore magna aliquatenim ad.
                </div>
              </div>
            </div>
          </div>
          {/* News Block Four */}
          <div className="news-block style-four wow fadeInRight">
            <div className="inner-box">
              <div className="image-box">
                <span className="tag">Marketing</span>
                <figure className="image">
                  <Link  to="blog-single.html">
                    <img src="/assets/images/resource/blog-4.jpg" alt="" />
                  </Link> 
                </figure>
              </div>
              <div className="lower-content">
                <div className="author">
                  <figure className="thumb">
                    <img src="/assets/images/resource/author-thumb-3.jpg" alt="" />
                  </figure>
                  <h5 className="name">Nicky Monitor</h5>
                </div>
                <ul className="post-info">
                  <li>
                    <span className="far fa-calendar" /> 31/12/2023
                  </li>
                  <li>
                    <span className="far fa-comments" /> 02 Comments
                  </li>
                </ul>
                <h4>
                  <Link  to="blog-single.html">
                    Why Lead Generation Is Key For Business Growth.
                  </Link> 
                </h4>
                <div className="text">
                  Single stroke at the present moment and yet I feel that lorem
                  quis bibendum auctor. Elitm sed eiusmod tempor incididunt umst
                  etsu dolore magna aliquatenim ad.
                </div>
              </div>
            </div>
          </div>
          <div className="styled-pagination">
            <ul>
              <li className="prev-post">
                <Link  to="#">
                  <span className="fa fa-angle-left" />
                </Link> 
              </li>
              <li>
                <Link  to="#">1</Link> 
              </li>
              <li className="active">
                <Link  to="#">2</Link> 
              </li>
              <li>
                <Link  to="#">3</Link> 
              </li>
              <li className="next-post">
                <Link  to="#">
                  <span className="fa fa-angle-right" />{" "}
                </Link> 
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/*Sidebar Side*/}
      <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
        <Link side className="sidebar padding-left">
          {/* Search */}
          <div className="sidebar-widget search-box">
            <form
              method="post"
              action="https://themecraze.net/html/volia/contact.html"
            >
              <div className="form-group">
                <input
                  type="search"
                  name="search-field"
                  defaultValue=""
                  placeholder="Search..."
                  required=""
                />
                <button type="submit">
                  <i className="icon flaticon-search" />
                </button>
              </div>
            </form>
          </div>
          {/* Category Widget */}
          <div className="sidebar-widget categories">
            <h5 className="sidebar-title">Categories</h5>
            <div className="widget-content">
              {/* Blog Category */}
              <ul className="blog-categories">
                <li>
                  <Link  to="blog-single.html">
                    Business <span>03</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Conference <span>07</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Digital <span>06</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Music <span>02</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Startup <span>06</span>
                  </Link> 
                </li>
                <li>
                  <Link  to="blog-single.html">
                    Workshop <span>09</span>
                  </Link> 
                </li>
              </ul>
            </div>
          </div>
          {/* Author Widget */}
          <div className="sidebar-widget author-widget">
            <div className="widget-content">
              {/* Author Block */}
              <div className="author-block">
                <div className="inner-box">
                  <figure className="author-image">
                    <img src="/assets/images/resource/author-img.jpg" alt="" />
                  </figure>
                  <div className="social-links">
                    <Link  to="#">
                      <i className="fab fa-facebook-f" />
                    </Link> 
                    <Link  to="#">
                      <i className="fab fa-dribbble" />
                    </Link> 
                    <Link  to="#">
                      <i className="fab fa-twitter" />
                    </Link> 
                    <Link  to="#">
                      <i className="fab fa-pinterest" />
                    </Link> 
                  </div>
                  <h5>Thomas May</h5>
                  <p>
                    Hear 9 inspiring talks, meet the best product people in
                    Europe, and party together after the event!
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Gallery Widget */}
          <div className="sidebar-widget gallery-widget">
            <h5 className="sidebar-title">Instagram</h5>
            <div className="widget-content">
              <div className="widget-content">
                <div className="outer clearfix">
                  <figure className="image">
                    <Link 
                      to="images/gallery/1.jpg"
                      className="lightbox-image"
                      title="Image Title Here"
                    >
                      <img src="/assets/images/resource/insta-2-1.jpg" alt="" />
                    </Link> 
                  </figure>
                  <figure className="image">
                    <Link 
                      to="images/gallery/2.jpg"
                      className="lightbox-image"
                      title="Image Title Here"
                    >
                      <img src="/assets/images/resource/insta-2-2.jpg" alt="" />
                    </Link> 
                  </figure>
                  <figure className="image">
                    <Link 
                      to="images/gallery/3.jpg"
                      className="lightbox-image"
                      title="Image Title Here"
                    >
                      <img src="/assets/images/resource/insta-2-3.jpg" alt="" />
                    </Link> 
                  </figure>
                  <figure className="image">
                    <Link 
                      to="images/gallery/4.jpg"
                      className="lightbox-image"
                      title="Image Title Here"
                    >
                      <img src="/assets/images/resource/insta-2-4.jpg" alt="" />
                    </Link> 
                  </figure>
                  <figure className="image">
                    <Link 
                      to="images/gallery/5.jpg"
                      className="lightbox-image"
                      title="Image Title Here"
                    >
                      <img src="/assets/images/resource/insta-2-5.jpg" alt="" />
                    </Link> 
                  </figure>
                  <figure className="image">
                    <Link 
                      to="images/gallery/1.jpg"
                      className="lightbox-image"
                      title="Image Title Here"
                    >
                      <img src="/assets/images/resource/insta-2-6.jpg" alt="" />
                    </Link> 
                  </figure>
                </div>
              </div>
            </div>
          </div>
          {/* Post Widget */}
          <div className="sidebar-widget popular-posts">
            <h5 className="sidebar-title">Recent Posts</h5>
            <div className="widget-content">
              <article rticle className="post">
                <div className="post-inner">
                  <figure className="post-thumb">
                    <Link  to="blog-single.html">
                      <img src="/assets/images/resource/post-thumb-1.jpg" alt="" />
                    </Link> 
                  </figure>
                  <div className="post-info">
                    <i className="fa fa-calendar-alt" /> 31/12/2023
                  </div>
                  <h6 className="text">
                    <Link  to="blog-single.html">
                      Chances are Good That There’s a Cloud Software
                    </Link> 
                  </h6>
                </div>
              </article>
              <article rticle className="post">
                <div className="post-inner">
                  <figure className="post-thumb">
                    <Link  to="blog-single.html">
                      <img src="/assets/images/resource/post-thumb-2.jpg" alt="" />
                    </Link> 
                  </figure>
                  <div className="post-info">
                    <i className="fa fa-calendar-alt" /> 31/12/2023
                  </div>
                  <h6 className="text">
                    <Link  to="blog-single.html">
                      We Have Top Executive and Start Up Here Event 2021
                    </Link> 
                  </h6>
                </div>
              </article>
              <article rticle className="post">
                <div className="post-inner">
                  <figure className="post-thumb">
                    <Link  to="blog-single.html">
                      <img src="/assets/images/resource/post-thumb-3.jpg" alt="" />
                    </Link> 
                  </figure>
                  <div className="post-info">
                    <i className="fa fa-calendar-alt" /> 31/12/2023
                  </div>
                  <h6>
                    <Link  to="blog-single.html">
                      Why Lead Generation is Key For Business Growth.
                    </Link> 
                  </h6>
                </div>
              </article>
            </div>
          </div>
          {/* Tags Widget */}
          <div className="sidebar-widget popular-tags">
            <h5 className="sidebar-title">Tags</h5>
            <div className="widget-content">
              <Link  to="#">Business</Link> 
              <Link  to="#">Conference</Link> 
              <Link  to="#">Speaker</Link> 
              <Link  to="#">Digital</Link> 
              <Link  to="#">Development</Link> 
              <Link  to="#">Venue</Link> 
              <Link  to="#">Tech</Link> 
              <Link  to="#">Workshop</Link> 
            </div>
          </div>
        </Link>
      </div>
    </div>
  </div>
</div>

  )
}

export default SideBar